import { useMemo } from "react";
import { useConfig } from "../useConfig";
export const useCountry = () => {
    const config = useConfig();
    return useMemo(() => ({
        countryName: config.COUNTRY_NAME,
        countryCode: config.ISO_COUNTRY_CODE,
    }), [config.COUNTRY_NAME, config.ISO_COUNTRY_CODE]);
};
//# sourceMappingURL=useCountry.js.map